import React, {useEffect, useState} from 'react'
import {Link, NavLink} from 'react-router-dom'
import styles from './Navbar.module.css'

const TopNavbar = () => {
    const [showNavbar, setShowNavbar] = useState(true);
    const [previousScrollPos, setPreviousScrollPos] = useState(0);

    useEffect(() => {
        const currentScrollPos = window.pageYOffset;
        if(currentScrollPos >= 10 && previousScrollPos === 0) {
            setShowNavbar(false);
        }
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            if (previousScrollPos > currentScrollPos) {
                setShowNavbar(true);
            } else {
                setShowNavbar(false);
            }
            setPreviousScrollPos(currentScrollPos);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [previousScrollPos]);
    return (
        <nav className={[styles.topnavbar, `${showNavbar ? styles.navbarVisible : styles.navbarHidden}`].join(' ')}>
            <div className={styles.flexcenter}>
                <Link to={'/'} className={styles.brandmark}>
                    <svg width="85pt" height="25pt" viewBox="0 0 85 25"><path d="M 12.359375 2.691406 L 12.359375 3.925781 L 3.90625 3.925781 L 3.90625 12.414062 L 2.683594 12.414062 L 2.683594 22.132812 L 12.359375 22.132812 L 12.359375 20.902344 L 20.808594 20.902344 L 20.808594 12.414062 L 22.03125 12.414062 L 22.03125 2.691406 Z M 5.101562 5.121094 L 19.613281 5.121094 L 19.613281 19.703125 L 5.101562 19.703125 Z M 27.335938 5.582031 L 27.335938 18.503906 L 34.902344 18.503906 L 34.902344 16.03125 L 29.984375 16.03125 L 29.984375 5.582031 Z M 67.492188 8.9375 C 64.796875 8.9375 62.613281 11.132812 62.613281 13.839844 C 62.613281 16.546875 64.796875 18.738281 67.492188 18.738281 C 70.183594 18.738281 72.367188 16.546875 72.367188 13.839844 C 72.367188 11.132812 70.183594 8.9375 67.492188 8.9375 Z M 40.386719 8.960938 C 38.402344 9.011719 36.460938 10.222656 35.832031 12.230469 C 35.207031 14.238281 35.753906 16.550781 37.492188 17.8125 C 39.53125 19.289062 43.5 19.097656 44.683594 16.605469 C 44.207031 16.390625 43.246094 15.808594 42.789062 15.835938 C 42.335938 15.867188 41.886719 16.277344 41.277344 16.445312 C 39.914062 16.835938 38.871094 16.042969 38.25 14.890625 L 45.058594 14.890625 C 45.375 13.101562 44.871094 11.027344 43.351562 9.882812 C 42.472656 9.222656 41.425781 8.933594 40.386719 8.960938 Z M 79.113281 8.976562 C 78.1875 8.972656 77.222656 9.308594 76.414062 9.953125 L 76.414062 9.191406 L 73.765625 9.191406 L 73.765625 18.503906 L 76.414062 18.503906 L 76.414062 13.945312 C 76.417969 13.4375 76.394531 12.890625 76.636719 12.429688 C 77.417969 10.953125 79.96875 10.84375 80.011719 13.753906 L 80.011719 18.503906 L 82.46875 18.503906 L 82.46875 13.945312 C 82.46875 13.152344 82.542969 12.003906 82.285156 11.28125 C 81.726562 9.722656 80.289062 9 79.113281 8.976562 Z M 51.679688 9 C 50.359375 9.066406 50.023438 9.257812 49.035156 10.140625 L 49.035156 9.191406 L 46.386719 9.191406 L 46.386719 18.503906 L 49.035156 18.503906 L 49.035156 14.703125 C 49.035156 12.710938 49.585938 11.855469 51.679688 11.660156 Z M 52.578125 9.191406 L 55.152344 15.464844 C 55.386719 16.035156 56.140625 17.597656 56.121094 18.125 C 56.078125 19.273438 54.832031 19.6875 53.90625 19.835938 L 53.90625 22.117188 C 54.644531 22.117188 55.273438 22.15625 55.984375 21.902344 C 56.492188 21.726562 56.914062 21.464844 57.273438 21.144531 C 58.570312 19.980469 59.058594 18.027344 59.65625 16.414062 L 62.226562 9.191406 L 59.710938 9.378906 L 58.246094 13.644531 L 57.6875 15.273438 C 57.6875 15.273438 57.511719 14.824219 57.238281 14.15625 C 56.863281 13.230469 55.992188 11.265625 55.5 10.167969 C 55.289062 9.695312 55.148438 9.386719 55.148438 9.386719 Z M 40.425781 11.128906 C 41.382812 11.128906 42.335938 11.75 42.601562 12.992188 L 38.25 12.992188 C 38.515625 11.75 39.46875 11.128906 40.425781 11.128906 Z M 67.492188 11.34375 C 68.863281 11.34375 69.972656 12.460938 69.972656 13.839844 C 69.972656 15.21875 68.863281 16.335938 67.492188 16.335938 C 66.121094 16.335938 65.007812 15.21875 65.007812 13.839844 C 65.007812 12.460938 66.121094 11.34375 67.492188 11.34375 Z M 67.492188 11.34375 "></path></svg>
                </Link>
            </div>
            <ul className={styles.flexcenter}>
                <li>
                    <NavLink exact className={({ isActive }) =>
                        isActive ? styles.active : undefined
                    } to="/">Home</NavLink>
                </li>
                <li>
                    <NavLink className={({ isActive }) =>
                        isActive ? styles.active : undefined
                    } to="/products">Products</NavLink>
                </li>
                <li>
                    <NavLink className={({ isActive }) =>
                        isActive ? styles.active : undefined
                    } to="/about">About</NavLink>
                </li>
                <li>
                    <NavLink className={({ isActive }) =>
                        isActive ? styles.active : undefined
                    } to="/media">Companies</NavLink>
                </li>
                <li>
                    <NavLink className={({ isActive }) =>
                        isActive ? styles.active : undefined
                    } to="/blog">Blog</NavLink>
                </li>
                <li>
                    <NavLink className={({ isActive }) =>
                        isActive ? styles.active : undefined
                    } to="/contact">Contact</NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default TopNavbar